import UsersTableHelper from './users-table-helper';
import usersFuncHelper from './users-functions-helper';
import UserLogsTableHelper from './users-logs-table-helper';
import { buildUserCreateUpdateInput } from './user-form-helper';

const UsersHelpers = {
    TableMain: UsersTableHelper,
    TableLogs : UserLogsTableHelper,
    Functions: usersFuncHelper,
    buildCreateUpdateInput: buildUserCreateUpdateInput,
}

export default UsersHelpers;
